module.exports = __webpack_public_path__ + "img/roulette-background.82549046.svg";